import {Component, Input} from '@angular/core';
import {Avatar} from 'primeng/avatar';
import {IniciaisNomePipe} from '@shared/pipes/iniciais-nome.pipe';

@Component({
  selector: 'app-menu-profile',
  standalone: true,
  imports: [
    Avatar,
    IniciaisNomePipe
  ],
  templateUrl: './menu-profile.component.html',
  styleUrl: './menu-profile.component.scss'
})
export class MenuProfileComponent {
  @Input() name: string = '';

  constructor() {
  }

}
